var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-container',{staticClass:"container"},[_c('el-header',{staticClass:"header"},[_c('Header')],1),_c('div',{staticClass:"main"},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }